<template>
  <div
    v-if="country"
    class="catches">
    <h2
      class="title">
      <translate>Fångster</translate>
    </h2>
    <b-table
      :data="truncatedResults"
      default-sort-direction="desc"
      default-sort="registration_time">
      <template slot-scope="props">
        <b-table-column
          field="team"
          sortable
          :custom-sort="sortTeam"
          :label="$gettext('Lag')">
          {{ getTeamName(props.row.team) }}
        </b-table-column>
        <b-table-column
          field="country"
          sortable
          :custom-sort="sortCountry"
          :label="$gettext('Land')">
          {{ getTeamCountry(props.row.team) }}
        </b-table-column>
        <b-table-column
          field="weight"
          :label="$gettext('Vikt')"
          sortable
          numeric
          :custom-sort="sortFloat">
          {{ props.row.weight.toLocaleString('fi-SV') }} kg
        </b-table-column>
        <b-table-column
          field="length"
          :label="$gettext('Längd')"
          sortable
          numeric>
          {{ props.row.length.toLocaleString('fi-SV') }} cm
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>


<script>
import { sortFloat } from '../_helpers';
import {
  teamService, countryService } from '../_services';

export default {
  name: 'Catches',
  props: {
    catches: {
      type: Array,
      default: () => {return []},
    },
    trunc: {
      type: Number,
      default: undefined,
    },
  },
  data () {
    return {
      sortFloat,
      country: undefined,
      teams: undefined,
    }
  },
  computed: {
    truncatedResults: function() {
      if (!this.trunc){
        return this.catches
      }
      let copy = this.catches.slice();

      return copy.slice(0,this.trunc)
    }
  },
  created() {
    var self = this
    self.fetch()
  },
  methods: {
    async fetch() {
      var self = this
      try{
        self.teams = await teamService.getAll()
        self.country = await countryService.getAll()
      }catch(err){

        console.error('Caught error')
        console.error(err)
      }
    },
    getTeamName: function(id){
      var self = this
      return self.teams.find( ({ pk }) => pk == id ).name
    },
    getTeamCountry: function(id){
      var self = this
      const team = self.teams.find( ({ pk }) => pk == id )
      const country = self.country.find( ({ pk }) => pk == team.country )
      return country.name
    },
    sortTeam: function(a, b, isAsc){
      var self = this
      let team_a = self.getTeamName(a.team)
      let team_b = self.getTeamName(b.team)
      if (team_a < team_b)
        if (isAsc === true){
          return 1;
        }else {
          return -1;
        }
      if ( team_a > team_b)
        if (isAsc === true){
          return -1;
        }else {
          return 1;
        }
      return 0;
    },
    sortCountry: function(a, b, isAsc){
      var self = this
      let team_a = self.getTeamCountry(a.team)
      let team_b = self.getTeamCountry(b.team)
      if (team_a < team_b)
        if (isAsc === true){
          return 1;
        }else {
          return -1;
        }
      if ( team_a > team_b)
        if (isAsc === true){
          return -1;
        }else {
          return 1;
        }
      return 0;
    },
  },
}
</script>
<style scoped>
.main-content {
  padding: 30px;
}
.competition {
  font-size: 12px;
}
.title {
  font-size: 1.5em;
}
.section {
  padding: 12px;
}
.panel {
  font-size: 1em;
}
.button {
  font-size: 12px;
}
</style>
